import * as React from 'react';
import ApiInfoBubble from './api-info-bubble';

export interface IStatTableProps {
    stats: {
        title: string;
        label: string;
        tipKey?: string;
    }[]
}
function StatTable({ stats }: IStatTableProps) {
    return <div className="stat-table">
        {stats.map((stat, i) => <>{stat.label && <article key={`stat${i}`}><div className="title"> {stat.title} </div><div className="value">{stat.label} <ApiInfoBubble index={stat.tipKey} placement="left" /></div></article>}</>)}
        </div>
}

export default StatTable;